/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import i18n from '@/i18n/i18n'

export default {
    fire({ state }, data) {
        state.toaster[data.type](data.message, data.title)
    },
    showValidationError({ state }, data) {
        state.toaster.options['timeOut'] = 0

        var errors = []

        for (const [key, value] of Object.entries(data.errors)) {
            let traduction = i18n.messages[i18n.locale]

            for (let i = 0; i < value.length; i++) {
                value[i] === 'validation.required'
                    ? (value[i] = traduction.error.validation.required)
                    : (value[i] = value[i])
            }
            errors.push(`${key}: ${value}`)
        }

        state.toaster['error'](errors.join('<br/>'), data.message)
    }
}
